import { Box, GridItem, Heading, Stack, Text } from '@chakra-ui/react'

import { SUMMER_CAMP_ILLUSTRATION_SRC } from '@/client/services/summerCamp'
import { getSummerCampExploreUrl } from '@/client/services/url'

import SignUpLink from '@/components/Auth/SignUpLink'
import ShwGrid from '@/components/Layout/ShwGrid'
import PublicImage from '@/components/PublicImage/PublicImage'
import ShwLink from '@/components/ShwLink'

const PARTICIPATE_STEPS = [
  {
    key: 'participate-step-1',
    name: () => (
      <Heading size="lg" as="h4" mb="16px">
        Join Schoolhouse for free
      </Heading>
    ),
    description: () => (
      <Text>
        <SignUpLink display="inline">Make a Schoolhouse account</SignUpLink> to get access to Summer
        Camp sessions, as well as free 1:1 and small-group tutoring in math, test prep, and more.
      </Text>
    ),
  },
  {
    key: 'participate-step-3',
    name: () => (
      <Heading size="lg" as="h4" mb="16px">
        Attend Summer Camp sessions
      </Heading>
    ),
    description: () => (
      <Text>
        Register for community-led{' '}
        <ShwLink href={getSummerCampExploreUrl()}>Summer Camp sessions</ShwLink>—sign up for as many
        as you want!
      </Text>
    ),
  },
]

export default function SummerCampHowToParticipate(): React.ReactElement {
  return (
    <ShwGrid alignItems="center" justifyItems="center">
      <GridItem colSpan={[12, 12, 12, 5]}>
        <Box>
          <PublicImage src={SUMMER_CAMP_ILLUSTRATION_SRC} maxWidth="90%" />
        </Box>
      </GridItem>
      <GridItem colSpan={[12, 12, 12, 7]}>
        <Stack direction="column" spacing={['24px', '32px']} px="16px" my="54px">
          <Heading size="2xl">How to participate</Heading>
          {PARTICIPATE_STEPS.map(({ key, name, description }, index) => (
            <Stack key={key} direction="row" spacing={4} align="left" width="100%">
              <Heading fontSize="48px" minWidth="32px" color="fg.subtle" fontWeight={900}>
                {index + 1}
              </Heading>
              <Box>
                {name()}
                {description()}
              </Box>
            </Stack>
          ))}
        </Stack>
      </GridItem>
    </ShwGrid>
  )
}
